// Публичная поверхность voice-recorder (SPEC §4.1/§4.2/§4.7).
//
// Доменные типы (VoiceContent/Waveform/Attachment/Message/SendMessageDTO/…) — только из
// @tele-chat/shared-contracts; здесь объявлены лишь типы UX-состояния записи, которыми модуль
// «владеет» (SPEC §2 «владеет-состоянием: UX записи»).
export const DEFAULT_LIMITS = {
    minDurationMs: 800,
    maxDurationMs: 600_000,
    peakBuckets: 64,
    sampleIntervalMs: 50,
    timesliceMs: 5000,
    stopFlushTimeoutMs: 2000,
};
//# sourceMappingURL=types.js.map